var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.chartTitle))]),_c('div',{staticClass:"chart-container"},[_c('canvas',{ref:"chart-container"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }